const theme = {
  colors: {
    light: {
      // Text colors
      text: {
        primary: '#FFFFFF',
        buttonDisabled: '#F6F6F6',
        secondary: '#85888F',
        regular: '#444447',
        disabled: '#C0C4CC',
        title: '#060606',
        error: '#F56C6C',
        errorLight: '#FAB5B5',
        success: '#67C23A',
        warning: '#F3B627',
        medium: '#606266',
        light: '#666',
        lighter: '#999',
      },

      // Primary brand colors
      primary: {
        primary: '#263CD0',
        dark: '#2539AE',
        light: '#779FFF',
        lighter: '#9EC3FF',
        lightest: '#C2DBFF',
        ultraLight: '#DDEBFF',
        background: '#ECF5FF',
        backgroundRgb: '236, 245, 255',
        accent: '#0052FF',
        purple: '#635BFF',
      },

      // Background colors
      background: {
        rgb: '255, 255, 255',
        primary: '#FFFFFF',
        secondPrimary: '#E4E4E4',
        secondary: '#F3F4F5',
        light: '#F5F6F7',
        lighter: '#FFFFFF',
        overlay: 'rgba(0, 0, 0, 0.5)',
        gradient: {
          primary:
            'linear-gradient(180deg, rgba(236, 245, 255, 0) 0%, rgba(236, 245, 255, 1) 100%)',
        },
      },

      // Border colors
      border: {
        primary: '#DCDFE6',
        secondary: '#E4E7ED',
        dashed: 'rgba(220, 223, 230, 1)',
      },

      // Status colors
      status: {
        success: {
          primary: '#67C23A',
          background: 'rgba(240, 249, 235, 1)',
          border: 'rgba(179, 224, 156, 1)',
          light: '#E1F3D8',
          lighter: '#F0F9EB',
          toast: '#DCFCE7',
        },
        warning: {
          primary: '#F3B627',
          secondary: '#E6A23C',
          background: '#FFEDC2',
          light: '#F8E3C5',
          lighter: '#FFF6E1',
        },
        error: {
          primary: '#F56C6C',
          background: '#FAB5B5',
          toast: '#FEE2E2',
        },
      },
      // Special colors for gradients and effects
      special: {
        purple: '#CAB3F5',
        shadow: 'rgba(0, 0, 0, 0.6)',
        modalShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
        cardShadow:
          '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
        skeleton: '#ecebeb',
        skeletonLight: '#e0e0e0',
        skeletonGradient:
          'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
      },
    },
    dark: {
      // Text colors
      text: {
        primary: '#000',
        buttonDisabled: '#272727',
        secondary: '#85888F',
        regular: '#C0C4CC',
        disabled: '#444447',
        title: '#FFFFFF',
        error: '#F56C6C',
        errorLight: '#7D3E3E',
        success: '#67C23A',
        warning: '#F3B627',
        medium: '#9E9E9E',
        light: '#A1A1A1',
        lighter: '#rgb(61 61 61)',
      },

      // Primary brand colors
      primary: {
        primary: '#779FFF',
        dark: '#3872FF',
        light: '#607FCD',
        lighter: '#486099',
        lightest: '#314166',
        ultraLight: '#1A2033',
        background: '#1D1E1F',
        backgroundRgb: '29, 30, 31',
        accent: '#0052FF',
        purple: '#635BFF',
      },

      // Background colors
      background: {
        rgb: '20, 20, 20',
        primary: '#141414',
        secondPrimary: '#424242',
        secondary: '#1E1E1E',
        light: '#2A2A2A',
        lighter: '#494A4D',
        overlay: 'rgba(0, 0, 0, 0.5)',
        gradient: {
          primary:
            'linear-gradient(180deg, rgba(20, 20, 20, 0) 0%, rgba(20, 20, 20, 1) 100%)',
        },
      },

      // Border colors
      border: {
        primary: '#3C3D3E',
        secondary: '#3A3A3A',
        dashed: 'rgba(60, 60, 60, 1)',
      },

      // Status colors
      status: {
        success: {
          primary: '#67C23A',
          background: '#1F2D1A',
          border: '#345B26',
          light: '#264C1F',
          lighter: '#142610',
          toast: '#1A3D1A',
        },
        warning: {
          primary: '#F3B627',
          secondary: '#E6A23C',
          background: '#3D2E14',
          light: '#4E3B1A',
          lighter: '#2A1D0D',
        },
        error: {
          primary: '#F56C6C',
          background: '#3A1E1E',
          toast: '#4D2A2A',
        },
      },

      // Special colors for gradients and effects
      special: {
        purple: '#CAB3F5',
        shadow: 'rgba(0, 0, 0, 0.6)',
        modalShadow: '0px 4px 10px rgba(0, 0, 0, 0.6)',
        cardShadow:
          '0 4px 8px 0 rgba(0, 0, 0, 0.4), 0 6px 20px 0 rgba(0, 0, 0, 0.35)',
        skeleton: '#2A2A2A',
        skeletonLight: '#333333',
        skeletonGradient:
          'linear-gradient(90deg, #2A2A2A 25%, #333333 50%, #2A2A2A 75%)',
      },
    },
    // Toast colors (keeping existing structure)
  },
};

export default theme;
